import { render, staticRenderFns } from "./RoundReceive.vue?vue&type=template&id=90f859ca&scoped=true&"
import script from "./RoundReceive.vue?vue&type=script&lang=js&"
export * from "./RoundReceive.vue?vue&type=script&lang=js&"
import style0 from "./RoundReceive.vue?vue&type=style&index=0&id=90f859ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f859ca",
  null
  
)

export default component.exports